import * as React from 'react';

const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path d='M9.99996 1.66602C5.41663 1.66602 1.66663 5.41602 1.66663 9.99935C1.66663 14.5827 5.41663 18.3327 9.99996 18.3327C14.5833 18.3327 18.3333 14.5827 18.3333 9.99935C18.3333 5.41602 14.5833 1.66602 9.99996 1.66602ZM10.8333 13.7493C10.8333 14.2493 10.5 14.5827 9.99996 14.5827C9.49996 14.5827 9.16663 14.2493 9.16663 13.7493C9.16663 12.8327 9.16663 10.916 9.16663 9.99935C9.16663 9.49935 9.49996 9.16602 9.99996 9.16602C10.5 9.16602 10.8333 9.49935 10.8333 9.99935C10.8333 10.916 10.8333 12.8327 10.8333 13.7493ZM8.91663 6.66602C8.91663 6.08268 9.41663 5.58268 9.99996 5.58268C10.5833 5.58268 11.0833 6.08268 11.0833 6.66602C11.0833 7.24935 10.5833 7.74935 9.99996 7.74935C9.41663 7.74935 8.91663 7.24935 8.91663 6.66602Z' />
		</svg>
	);
};

export default InfoIcon;
